<template>
  <!-- 課輔媒合 課輔中 -->
  <div>
    <!-- 無資料時 老師視角 -->
    <template v-if="!loadingFlag">
      <template v-if="coachType===10 && matchList.length === 0" >
        <div class="page-empty">
          <img src="../../../images/background-img/study-grey.png" alt />
          <h3>目前尚無課輔中的課程</h3>
          <p><a href="">教課資訊</a> 填寫完畢後，學生即可搜尋到您。當有人詢問您的課程時，將會以此 Email 通知：<span>s93565@stu.stu.tw</span></p>
        </div>
      </template>
    </template>

    <!-- 無資料時 學生視角 -->
    <template v-if="!loadingFlag">
      <template v-if="coachType===20 && matchList.length === 0" >
        <div class="page-empty">
          <img src="../../../images/background-img/study-grey.png" alt />
          <h3>目前尚無課輔中的課程</h3>
          <p>目前尚無課程，請點選<a href>申請輔導</a></p>
        </div>
      </template>
    </template>

    <!-- 有資料時 -->
    <div class="list media-list" v-if="!loadingFlag">
      <ul>
        <li v-for="(item,index) in supplementList">
          <div class="item-content" @click="checkHref('counseling-record',item.id,item.classImagePath,item.classHours,item.courseCode,item.applyStatus,item[matchNameKey],item.courseName,item.updatedAt,item.updatedBy,item[matchKey])">
            <div 
              class="item-media list-avatar"
              style="background-image:url(https://randomuser.me/api/portraits/men/4.jpg)"
              ></div>
              <div class="item-inner">
                <div class="item-title-row">
                  <div class="item-title">{{ item.courseName }}</div>
                </div>
                <div class="item-subtitle">{{ item[matchNameKey] }}</div>
              </div>
          </div>
        </li>
      </ul>
      <!--
      <ul>
        <li>
          <div class="item-content" @click="checkHref('counseling-record')">
            <div
              class="item-media list-avatar"
              style="background-image: url(https://randomuser.me/api/portraits/men/4.jpg)"
            ></div>
            <div class="item-inner">
              <div class="item-title-row">
                <div class="item-title">基礎電機學</div>
              </div>
              <div class="item-subtitle">陳東東</div>
            </div>
          </div>
        </li>
        <li>
          <div class="item-content" @click="checkHref('counseling-record')">
            <div
              class="item-media list-avatar"
              style="background-image: url(https://randomuser.me/api/portraits/men/90.jpg)"
            ></div>
            <div class="item-inner">
              <div class="item-title-row">
                <div class="item-title">微積分</div>
              </div>
              <div class="item-subtitle">王大明</div>
            </div>
          </div>
        </li>
      </ul>
      -->
    </div>
  </div>
</template>

<script>
import Service from "../../../service";
import axios from '../../../js/axiosModule';
import { bus } from '../../../js/bus.js';
export default {
  components: {},
  data() {
    return {
      dish: Service.getDish(this.$f7route.params.id),
      supplementList:[],
      coachType:this.$store.state.coachType,
      loadingFlag:false,
      matchKey:this.$store.state.coachType===10 ? "tutee":"tutor",
      matchNameKey:this.$store.state.coachType===10 ? "tuteeName":"tutorName"
    };
  },
  created: function() {
    let self = this;
    bus.$on('supplementBus',function(res){
    //  console.log(res);
      self.loadingFlag = true;
      self.supplementList = res.supplementList;
      self.loadingFlag = false;
    });

  },
  methods: {
    checkHref: function(linkText,id,classImagePath,classHours,courseCode,applyStatus,chineseName,courseName,updateAt,studentno) {
      window.localStorage.removeItem("classImagePathStr");
            window.localStorage.removeItem("courseCodeStr");
            window.localStorage.setItem("classImagePathStr",classImagePath);
             window.localStorage.setItem("courseCodeStr",id);
     return new Promise((resolve,reject) => {
        this.$f7router.navigate("/" + linkText);
        setTimeout(
          function() {
            bus.$emit("record-bus",{"id":id,"classImagePath":classImagePath,"classHours":classHours,"courseCode":courseCode,"applyStatus":applyStatus,"chineseName":chineseName,"courseName":courseName,"updateAt":updateAt,"updatedBy":updatedBy,"studentno":studentno});
            
          }
        ,100);
      });
      
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/pages/academic-counseling/counseling/counseling-item.vue